// Utilidades de fecha compartidas por los paneles del dashboard.
// La API devuelve fechas en varios formatos: ISO ("2026-05-06T00:00:00.000Z"),
// "dd/mm/yyyy" o "dd/mm/yyyy hh:mm:ss". parseFecha las normaliza a Date.

export const parseFecha = (valor) => {
    if (!valor) return null;
    if (valor instanceof Date) return isNaN(valor.getTime()) ? null : valor;

    const texto = String(valor).trim();

    // "dd/mm/yyyy[ hh:mm:ss]"
    const ddmmyyyy = texto.substr(0, 10).match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
    if (ddmmyyyy) {
        const [, d, m, y] = ddmmyyyy;
        const fecha = new Date(+y, +m - 1, +d);
        return isNaN(fecha.getTime()) ? null : fecha;
    }

    // "yyyy-mm-dd..." (ISO). Se toman solo los componentes de fecha y se
    // construye en hora local para evitar el corrimiento de día por zona
    // horaria (las fechas vienen como medianoche UTC).
    const ymd = texto.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (ymd) {
        const [, y, m, d] = ymd;
        const fecha = new Date(+y, +m - 1, +d);
        return isNaN(fecha.getTime()) ? null : fecha;
    }

    const fecha = new Date(texto);
    return isNaN(fecha.getTime()) ? null : fecha;
};

// Días enteros desde hoy hasta `fecha` (negativo si ya pasó).
export const diasHasta = (fecha) => {
    const hoy = new Date();
    hoy.setHours(0, 0, 0, 0);
    return Math.round((fecha.getTime() - hoy.getTime()) / 86400000);
};

export const fechaCorta = (fecha) =>
    fecha ? fecha.toLocaleDateString("es-SV") : "";
